import { useEffect, useState } from 'react'

import {
  calculateProgressValue,
  calculateTimeRemaining,
  type TimeRemaining,
} from '../../presenters/tenderListCardPresenter'

const TIME_REMAINING_UPDATE_INTERVAL_MS = 60000

export function useTenderExpiration(expirationDate?: Date) {
  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining>({
    hours: 0,
    minutes: 0,
  })
  const [progressValue, setProgressValue] = useState(expirationDate ? 100 : 0)

  useEffect(() => {
    if (!expirationDate) {
      setTimeRemaining({ hours: 0, minutes: 0 })
      setProgressValue(0)
      return
    }

    function updateTimeRemaining() {
      setTimeRemaining(calculateTimeRemaining(expirationDate))
      setProgressValue(calculateProgressValue(expirationDate))
    }

    updateTimeRemaining()
    const interval = setInterval(updateTimeRemaining, TIME_REMAINING_UPDATE_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [expirationDate])

  return { timeRemaining, progressValue }
}
